import { Injectable } from "@angular/core";
import { UserProvider } from "../../providers/user/user";
import { Observable } from "rxjs/Observable";

@Injectable()
export class RecuperarSenhaPageProvider {
    constructor(public userProvider: UserProvider) {

    }

    recuperarSenha(email: string): Observable<any> {
        return Observable.create(subscriber => {
            this.userProvider.recuperarSenha(email).subscribe((data) => {
                subscriber.next(data)
            })
        })
    }
}


// WEBPACK FOOTER //
// ./src/pages/recuperar-senha/recuperar-senha.provider.ts